
  // Mobile search input handling
  const mobileSearchInput = document.querySelector("input.search__input");
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener("keyup", (e) => {
      const valueLength = e.target.value.length;
      if (valueLength > 0) {
        document.querySelector(".search__content").classList.add('flexOrder');
        document.querySelector(".recent-searched-products").style.display = "none";

      } else {
        document.querySelector(".search__content").classList.remove('flexOrder');
        document.querySelector(".recent-searched-products").style.display = "block";

      }
    });
  }

